import React from "react";


export default function SpinnerButton() {
    return (
        <div className="pds-util-inline-flex pds-animatedIcon" aria-label="loading">
        <i data-feather="loader" aria-hidden="true"></i>
      </div>
    );
  }